import { useAuth } from '@clerk/nextjs'
import { useCheckout } from '@components/_checkout/CheckoutProvider'
import { useResetClient } from '@components/UrqlClientProvider'
import { Role, useMeQuery } from '@generated'
import { useRouter } from 'next/router'
import { useCallback, useEffect } from 'react'

export function useMe() {
  const { isSignedIn, signOut, isLoaded } = useAuth()
  const { resetClient } = useResetClient()
  const { clear } = useCheckout()
  const router = useRouter()

  const [{ data, fetching }, reexecuteQuery] = useMeQuery({
    requestPolicy: 'network-only',
    pause: !isSignedIn,
  })

  // Redirect to complete account page if the user is logged in and has not completed their account
  useEffect(() => {
    if (
      !fetching &&
      data?.me?.isAccountComplete === false &&
      router.pathname !== '/account/complete' &&
      data?.me?.role !== Role.Admin
    ) {
      router.push('/account/complete')
    }
  }, [data?.me?.isAccountComplete, router, fetching, data?.me?.role])

  const logout = useCallback(async () => {
    await signOut(() => {
      clear()
      resetClient()
    })
  }, [clear, resetClient, signOut])

  const refetch = useCallback(() => {
    return reexecuteQuery({ requestPolicy: 'network-only' })
  }, [reexecuteQuery])

  return {
    isLoggedIn: isSignedIn,
    isLoading: fetching || !isLoaded,
    logout,
    me: data?.me,
    addresses: data?.addresses || [],
    refetch,
  }
}
